import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {I18n, type TranslationObject} from '@colonist/i18n'
import {StringUtils} from '@colonist/utils'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {createOptionIn, createSelectIn, setElementOnClick} from '../ui_utils/DomUtils.ts'
import {ViewPopup} from './ViewPopup.ts'
import {clientIntl, replaceLanguageInPath} from '../ClientI18n.ts'
import {StorageWrapper} from '../StorageWrapper.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export class ViewPopupLanguage extends ViewPopup {
    private readonly supportedLanguages: string[]
    private readonly currentLanguage: string
    private selectedLanguage: string

    constructor() {
        const changeLanguagePopupTitle: TranslationObject = {key: 'strings:homePage.footer.changeLanguagePopupTitle'}
        const changeLanguagePopupBodyKey: TranslationObject = {key: 'strings:homePage.footer.changeLanguagePopupBody'}
        super(changeLanguagePopupTitle, changeLanguagePopupBodyKey, () => undefined, () => undefined, true)
        this.supportedLanguages = I18n.languages
        this.currentLanguage = UIUtilsEjsVariables.language
        this.createLanguageSelect()
        setElementOnClick(this.checkButton, () => void this.setLanguage())
        this.body.classList.add('language-popup')
        this.removeXButton()
        this.show()
    }

    private createLanguageSelect() {
        const languageSelect = createSelectIn(this.body, '', '', (value: string) => this.selectedLanguage = value)
        this.supportedLanguages.forEach((languageCode: string) => {
            const languageName = clientIntl.getLanguageName(languageCode)
            if(languageName == undefined) return
            const languageNameCapitalized = StringUtils.capitalizeFirstLetter(languageName)
            const nativeLanguageName = clientIntl.getLanguageName(languageCode, languageCode)
            if(nativeLanguageName == undefined) return
            const nativeLanguageNameCapitalized = StringUtils.capitalizeFirstLetter(nativeLanguageName)
            const displayName = `${languageNameCapitalized} (${nativeLanguageNameCapitalized})`
            createOptionIn(languageSelect, languageCode, {key: 'strings:colonistCommon.utils.#buffer', options: {value: displayName}})
        })
        languageSelect.selectedIndex = this.supportedLanguages.indexOf(this.currentLanguage)
        this.selectedLanguage = languageSelect.value
    }

    private async setLanguage() {
        AudioManager.play(AudioType.Click)
        this.removePopup()
        StorageWrapper.setLanguage(this.selectedLanguage)
        if(this.selectedLanguage == this.currentLanguage) return
        const dataToSend = {language: this.selectedLanguage} as AjaxDataTypes.LanguageChangeData
        await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSetUserLanguage(), undefined, dataToSend, 'application/json')

        window.location.pathname = replaceLanguageInPath(window.location.pathname, this.selectedLanguage)
    }
}
